import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { EmailApiClient } from "../api-client/api-client";
import type { NewEmailMutationProps } from "../../types";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { QueryOptionsFactory } from "@/features/company/utils";

export const useCreateEmail = () => {
  const { leUuid } = useCompanyContext();
  const queryClient = useQueryClient();

  const useCheckEmailMutation = (
    options?: UseMutationOptions<NewEmailMutationProps, Error, string>
  ) => {
    const { t } = useTranslation(["pass"]);
    return useMutation<NewEmailMutationProps, Error, string>({
      mutationFn: async (email: string) => {
        try {
          return await EmailApiClient.checkAlias(email, leUuid as string);
        } catch (_) {
          throw new Error(t("olkypass.general.mail_already_exist"));
        }
      },
      onSuccess: () =>
        leUuid
          ? queryClient.invalidateQueries({
              queryKey: QueryOptionsFactory.legalEntity(leUuid ?? "").queryKey
            })
          : queryClient.invalidateQueries({ queryKey: ["user", "profile"] }),
      ...options
    });
  };

  return {
    useCheckEmailMutation
  };
};
